var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApprovals(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_381_35)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 9.99999C20 8.64499 19.405 7.36665 18.3958 6.56332C18.5125 5.21165 18.0292 3.88749 17.0708 2.92832C16.1125 1.97082 14.7917 1.48832 13.5067 1.63249C11.8283 -0.497514 8.2025 -0.537514 6.56333 1.60332C5.21 1.48332 3.8875 1.96915 2.92917 2.92832C1.97167 3.88665 1.48834 5.21165 1.63334 6.49249C-0.496665 8.17082 -0.537498 11.7967 1.60417 13.4367C1.4875 14.7883 1.97084 16.1125 2.92917 17.0717C3.8875 18.0292 5.21 18.5133 6.49333 18.3675C8.17167 20.4975 11.7975 20.5375 13.4367 18.3967C14.7867 18.51 16.1117 18.0308 17.0708 17.0717C18.0283 16.1133 18.5117 14.7883 18.3667 13.5075C19.405 12.6342 20 11.3558 20 10.0008V9.99999ZM14.6167 8.80499L10.6675 12.6117C9.69833 13.5792 8.1125 13.5708 7.14333 12.6008L5.26667 10.8575C4.93 10.5442 4.91 10.0167 5.22334 9.67999C5.5375 9.34249 6.06583 9.32415 6.40084 9.63665L8.29917 11.4008C8.6475 11.7483 9.17417 11.7475 9.49917 11.4217L13.4592 7.60415C13.7908 7.28582 14.3183 7.29499 14.6375 7.62582C14.9575 7.95665 14.9475 8.48499 14.6167 8.80415V8.80499Z",
    fill: "url(#paint0_linear_381_35)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_381_35",
    x1: 10.0084,
    y1: 0.0162354,
    x2: 10.0084,
    y2: 19.9837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91C04A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009EDB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_381_35"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprovals);
export default __webpack_public_path__ + "static/media/approvals.adf360ee270a5f7cf3ff79fe375d27da.svg";
export { ForwardRef as ReactComponent };